// Unified Fulfillment State Machine phase — single frontend source of truth for
// CustomerOrder.fulfillmentStatus, mirroring server/utils/orderConstants.js FULFILLMENT_STATUS and
// the role-scoped transitions in server/services/orderStateMachine.js
// (FULFILLMENT_ROLE_TRANSITIONS). AdminDashboard.js and CollectorDashboard.js both import from
// here instead of keeping their own separately-drifting label/action objects.
export const FULFILLMENT_STATUS = {
  WAITING: 'waiting',
  ASSIGNED: 'assigned',
  COLLECTING: 'collecting',
  COLLECTED: 'collected',
  SHIPPED: 'shipped',
  COMPLETED: 'completed',
};

export const FULFILLMENT_STATUS_LABELS = {
  [FULFILLMENT_STATUS.WAITING]: 'Ожидает сборки',
  [FULFILLMENT_STATUS.ASSIGNED]: 'Назначен',
  [FULFILLMENT_STATUS.COLLECTING]: 'Сборка',
  [FULFILLMENT_STATUS.COLLECTED]: 'Собран',
  [FULFILLMENT_STATUS.SHIPPED]: 'Передан в доставку',
  [FULFILLMENT_STATUS.COMPLETED]: 'Завершён',
};

// Admin's only fulfillment-status-mutating action via PATCH /api/admin/orders/:id/status, keyed by
// the order's CURRENT status. waiting -> assigned happens exclusively through the dedicated
// assign-worker endpoint, never this generic one — so 'waiting' has no entry here. Must stay in
// sync with orderStateMachine.js FULFILLMENT_ROLE_TRANSITIONS.ADMIN.
export const ADMIN_NEXT_ACTION = {
  [FULFILLMENT_STATUS.COLLECTED]: { target: FULFILLMENT_STATUS.SHIPPED, label: 'Передать в доставку' },
  [FULFILLMENT_STATUS.SHIPPED]: { target: FULFILLMENT_STATUS.COMPLETED, label: 'Завершить' },
};

// Collector's only fulfillment-status-mutating action via PATCH /api/collector/orders/:id/status,
// keyed by the order's CURRENT status. Must stay in sync with orderStateMachine.js
// FULFILLMENT_ROLE_TRANSITIONS.COLLECTOR.
export const COLLECTOR_NEXT_ACTION = {
  [FULFILLMENT_STATUS.ASSIGNED]: { target: FULFILLMENT_STATUS.COLLECTING, label: 'Начать сборку' },
  [FULFILLMENT_STATUS.COLLECTING]: { target: FULFILLMENT_STATUS.COLLECTED, label: 'Собрано' },
};
